import './step.css';
import { IStepComponentProps } from './interfaces/IStepComponentProps';
import { useSelector } from 'react-redux';
import { RootState } from '../../../state/store';

const Step = ({heading, description, index, isLastStep}: IStepComponentProps) => {
  const language: string = useSelector((state: RootState) => state.language.value);
  return <div className={`home__our-process-step-${index}`}>
		<div className="row-1">
			<div className="col-1">
				<div className='home__our-process-step-circle'>{index}</div>
				<div className={`home__our-process-step-line${language === "BG" ? ' lang-bg' : ''}`} style={{height: `${isLastStep ? '50%' : ''}`}}></div>
			</div>
			<div className="col-2">
				<h4>{heading}</h4>
				<p>{description}</p>
			</div>
		</div>
	</div>
}

export default Step
